export default {
    nav: {
        dashboard:     'Nadzorna soba',
        shifts:        'Dnevna evidenca',
        tickets:       'Prijave napak',
        faults:        'Evidenca napak',
        incidents:     'Pomoč pri reševanju napak',
        plan:          'Plan dobav',
        reports:       'Poročila',
        guide:         'Navodila za uporabo',
        electricity:   'Poraba elektrike',
        personnel:     'Delavci in ekipe',
        reference:     'Dobavitelji in materiali',
        schedule:      'Urnik obratovanja',
        field_bounds:  'Meje kakovosti',
        users:         'Uporabniki',
    },
    app: {
        name:    'XRT',
        company: 'Meltal Group',
    },
    theme: {
        system: 'Sistemska tema',
        light:  'Svetla tema',
        dark:   'Temna tema',
    },
    nav_groups: {
        production:  'Proizvodnja',
        maintenance: 'Vzdrževanje',
        data:        'Podatki',
        admin:       'Administracija',
    },
    electricity: {
        title:                  'Poraba elektrike',
        meter_banot:            'Poraba elektrike - Banot',
        meter_linija:           'Poraba elektrike - Linija',
        previous_reading:       'Prejšnje stanje',
        no_previous_reading:    'Ni še prejšnjega vnosa.',
        current_reading:        'Trenutno stanje števca',
        consumption:            'Poraba ta mesec',
        reminder:               'Danes je zadnji dan v mesecu — vnesi stanje števcev elektrike (Banot in linija) za ta mesec.',
        reminder_action:        'Vnesi stanje',
    },
    tickets: {
        title:              'Prijave napak',
        new_placeholder:    'Npr. Na transporterju P28 je potrebno zamenjati vetrnico ...',
        priority:           'Prioriteta',
        priority_high:      'Visoka',
        priority_medium:    'Srednja',
        priority_low:       'Nizka',
        status:             'Status',
        status_open:        'Odprto',
        status_in_progress: 'V delu',
        status_resolved:    'Rešeno',
        reported_by:        'Prijavil',
        resolved_by:        'Rešil',
        resolution_note:    'Opomba ob rešitvi',
        resolution_note_placeholder: 'Kaj je bilo narejeno (neobvezno) ...',
        mark_in_progress:   'V delu',
        mark_resolved:      'Rešeno',
        reopen:             'Ponovno odpri',
        report:             'Prijavi',
        delete:             'Izbriši',
        confirm_delete:     'Izbrišem to prijavo?',
        filter_all_priorities: 'Vse prioritete',
        pending_section:    'Čaka na delo',
        resolved_section:   'Rešeno',
        empty:              'Trenutno ni odprtih prijav.',
        empty_resolved:     'Ni še rešenih prijav.',
    },
    faults: {
        phrases: [
            'popravilo na banotu',
            'menjava nožev in kontra nožev',
            'napaka rtg, ponovni zagon',
            'zategovanje vijakov',
            'zamenjava valja na pušerju',
        ],
        title:           'Evidenca napak',
        shift:           'Obratovalni cikel',
        start_at:        'Začetek',
        end_at:          'Konec',
        description:     'Opis napake',
        duration:        'Trajanje',
        delete:          'Izbriši',
        confirm_delete:  'Izbrišem ta zapis o napaki?',
        new:             'Nova napaka',
        edit:            'Uredi napako',
    },
    incidents: {
        title:           'Pomoč pri reševanju napak',
        new:             'Nov izredni dogodek',
        detail:          'Podrobnosti dogodka',
        list_title:      'Naslov',
        date:            'Datum',
        component:       'Sklop / komponenta',
        description:     'Kaj se je zgodilo',
        cause:           'Vzrok',
        resolution:      'Kako je bilo odpravljeno',
        resolved_by:     'Odpravil',
        status:          'Status',
        downtime_hours:  'Izpad linije (ur)',
        status_open:            'Odprto',
        status_in_progress:     'V obravnavi',
        status_resolved:        'Rešeno',
        search:          'Iskanje po naslovu, opisu, vzroku, rešitvi ...',
        save:            'Shrani',
        delete:          'Izbriši',
        confirm_delete:  'Izbrišem ta izredni dogodek?',
    },
    reference: {
        title:          'Dobavitelji in materiali',
        suppliers:      'Dobavitelji',
        materials:      'Materiali',
        name:           'Naziv',
        active:         'Aktiven',
        new_supplier:   'Nov dobavitelj',
        new_material:   'Nov material',
        edit:           'Uredi',
    },
    personnel: {
        title:              'Delavci in ekipe',
        workers:            'Delavci',
        teams:              'Ekipe',
        rotation:           'Tedenska rotacija',
        roster_exceptions:  'Izjeme razporeda',
        roster_preview:     'Pregled razporeda',
        name:               'Ime',
        team:               'Ekipa',
        active:             'Aktiven',
        operator:           'Strojnik',
        operators:          'Strojniki',
        bulk_add:           'Dodaj več delavcev',
        bulk_help:          'Prilepi seznam imen (eno ime v vrstici). Vrstice z urami, npr. 149:40, se preskočijo, že obstoječa imena se ne podvojijo.',
        bulk_result:        'Dodanih: {added}, preskočenih (že obstajajo): {skipped}',
        new_worker:         'Nov delavec',
        new_team:           'Nova ekipa',
        effective_from:     'Velja od (ponedeljek)',
        reference_week_start: 'Referenčni teden (ponedeljek)',
        team_morning:       'Ekipa - dopoldan',
        team_afternoon:     'Ekipa - popoldan',
        new_rule:           'Novo pravilo rotacije',
        week_start:         'Teden (ponedeljek)',
        scope:              'Vrsta izjeme',
        scope_team_swap:    'Zamenjava celotne ekipe',
        scope_worker:       'En delavec',
        worker:             'Delavec',
        shift_field:        'Izmena',
        morning:            'Dopoldan',
        afternoon:          'Popoldan',
        note:               'Opomba',
        new_exception:      'Nova izjema',
        select_date:        'Izberi datum',
        not_defined:        'Za izbrani teden razpored še ni definiran.',
        delete:             'Izbriši',
    },
    reports: {
        title:                  'Poročila',
        year:                   'Leto',
        month:                  'Mesec',
        annual:                 'Letno',
        total_input_qty_kg:     'Vhod skupaj (kg)',
        total_good_pieces_kg:   'Dobri kosi skupaj (kg)',
        total_gross_hours:      'Bruto ure skupaj',
        total_effective_hours:  'Efektivne ure skupaj',
        total_fault_hours:      'Ure napak skupaj',
        scheduled_hours:        'Razpoložljive ure (urnik)',
        capacity_utilization:   'Izkoriščenost',
        throughput_effective:   'Obdelava / efektivno uro',
        throughput_gross:       'Obdelava / bruto uro',
        target_achievement:     'Doseganje cilja',
        shift_count:            'Št. ciklov',
        electricity:            'Poraba elektrike (kWh)',
        plan_vs_actual:         'Plan dobav proti dejanskemu',
        supplier:               'Dobavitelj',
        material:               'Material',
        planned:                'Načrtovano (kg)',
        actual:                 'Dejansko (kg)',
        difference:             'Razlika (kg)',
        export:                 'Izvoz dnevne evidence',
        export_csv:             'Izvozi CSV',
        export_xlsx:            'Izvozi Excel',
    },
    plan: {
        status_expected:  'Pričakovano',
        status_partial:   'Delno dostavljeno',
        status_delivered: 'Dostavljeno',
        status_delayed:   'Zamuja',
        targets:          'Letni in mesečni cilj',
        annual_target:    'Letni cilj (kg)',
        monthly_target:   'Mesečni cilj (kg)',
        save:             'Shrani',
    },
    schedule: {
        title:          'Urnik obratovanja',
        versions:       'Različice urnika',
        exceptions:     'Izjeme po datumu',
        effective_from: 'Velja od',
        weekly:         'Tedenska predloga',
        working:        'Obratuje',
        start_time:     'Začetek',
        end_time:       'Konec',
        date:           'Datum',
        note:           'Opomba',
        new_version:    'Nova različica',
        new_exception:  'Nova izjema',
        delete:         'Izbriši',
        confirm_delete: 'Izbrišem to izjemo?',
    },
    field_bounds: {
        title:       'Meje kakovosti vnosa',
        field:       'Polje',
        min:         'Spodnja meja',
        max:         'Zgornja meja',
        source:      'Vir',
        manual:      'Ročno',
        computed:    'Samodejno',
        reset:       'Povrni na samodejno',
        save:        'Shrani',
    },
    users: {
        title:       'Uporabniki',
        name:        'Ime',
        username:    'Uporabniško ime',
        role:        'Vloga',
        active:      'Aktiven',
        password:    'Geslo',
        new_password: 'Novo geslo (pusti prazno, če se ne spreminja)',
        new_user:    'Nov uporabnik',
        role_entry:  'Vnašalec',
        role_admin:  'Administrator',
        role_viewer: 'Pregledovalec',
        pin:         'PIN (4 mesta)',
        pin_invalid: 'PIN mora imeti natanko 4 številke',
        reset_pin:   'Ponastavi PIN',
    },
    shifts: {
        title:            'Dnevna evidenca',
        new:              'Nov vnos',
        detail:           'Podrobnosti',
        start_at:         'Začetek',
        end_at:           'Konec',
        supplier:         'Dobavitelj',
        material:         'Material',
        input_qty_kg:     'Vhod materiala (kg)',
        good_pieces_kg:   'Izhod dobrih kosov (kg)',
        gross_hours:      'Bruto ure',
        effective_hours:  'Efektivne ure',
        electricity_meter_start: 'Števec elektrike - začetek',
        electricity_meter_end:   'Števec elektrike - konec',
        notes:            'Opombe',
        save:             'Shrani',
        outside_schedule: 'Cikel delno pade izven urnika obratovanja.',
        photos:           'Slike',
        add_photo:        'Dodaj sliko',
        section_input:       'Vhod materiala',
        section_output:      'Izhod materiala',
        section_electricity: 'Poraba elektrike',
        section_time:        'Čas obratovanja',
        operators:           'Strojniki na liniji',
        no_operators:        'Ni strojnikov — dodaj jih pod Delavci in ekipe.',
        section_faults:      'Evidenca napak med tem ciklom',
        workers_count:       'Število sortircev na liniji',
        sorter_hours:        'Ure sortiranja (h)',
        cleaning_hours:      'Čiščenje linije (h)',
        maintenance_hours:   'Vzdrževanje (h)',
        output_waste:               'Smeti (kg)',
        output_fe:                  'Železo (Fe) (kg)',
        output_inox:                'Inox (kg)',
        output_mix_sheet:           'Mešana pločevina (kg)',
        output_hard_clean:          'Trda čista (kg)',
        output_hard_fe:             'Trda FE (kg)',
        output_profiles_hute:       'Profili hute (kg)',
        output_mix_sheet_weighed:   'Mešana pločevina - tehtana (kg)',
        output_almg:                'AlMg (kg)',
        output_shoot:               'Shoot (kg)',
        output_shavings_pre_mill:   'Ostružki pred mlinom (kg)',
        output_filter_dust:         'Filterski prah (kg)',
        output_shavings_post_mill:  'Ostružki po mlinu (kg)',
        output_exceeds_input: 'Dobri kosi presegajo vhod materiala — preveri vnos.',
        add_material:     'Dodaj material',
        quantity_kg:      'Količina (kg)',
        other_material:      'Drugo (vpiši material)',
        other_material_name: 'Ime materiala',
        faults_help:      'Vnesi jih kar tu, sproti — brez posebnega koraka.',
        no_faults:        'Ni vnesenih napak za ta cikel.',
        add_fault:        'Dodaj napako',
        fault_duration_hours: 'Trajanje (h)',
        quick_fault:      'ali hitro dodaj pogosto:',
        end_before_start: 'Konec mora biti za začetkom.',
        meter_end_before_start: 'Končno stanje števca ne more biti manjše od začetnega.',
        warning_input_out_of_range: 'Vhod materiala odstopa od običajnih vrednosti — preveri vnos.',
        warning_good_out_of_range:  'Izhod dobrih kosov odstopa od običajnih vrednosti — preveri vnos.',
        warning_electricity_out_of_range: 'Poraba elektrike odstopa od običajnih vrednosti — preveri stanji števca.',
        warning_output_mismatch: 'Vsota izhodnega materiala precej presega vhod — preveri vnos.',
        fault_needs_description: 'Pri napaki vpiši opis.',
        fault_needs_duration:    'Pri napaki vpiši trajanje, večje od 0.',
        entered_by:           'Vnesel',
        trace:                'Sledljivost',
        trace_created:        'Vpisal',
        trace_edited:         'Zadnja sprememba',
        trace_history:        'Zgodovina sprememb',
        trace_history_none:   'Ni zabeleženih sprememb.',
        trace_field:          'Polje',
        trace_old:            'Prej',
        trace_new:            'Potem',
        trace_by:             'Kdo',
        trace_when:           'Kdaj',
        existing_faults:      'Vnesene napake za ta cikel',
        fault_correction:     'Popravek za pretekli vnos',
        fault_correction_help: 'Če je bila napaka pri vnosu pozabljena ali napačno vnesena, jo lahko dodaš, urediš ali izbrišeš tudi po shranitvi cikla.',
        save_changes:         'Shrani spremembe',
    },
    dashboard: {
        title:              'Nadzorna soba',
        logout:             'Odjava',
        go_to_shifts:       'Dnevna evidenca',
        fullscreen:         'Celozaslonski način',
        exit_fullscreen:    'Zapri celozaslonski način',
        new_entry_sub:      'Dobavitelj, material, izhod, ure in napake na enem mestu',
        ytd_output:         'Predelano letos skupaj',
        month_output:       'Predelano ta mesec',
        utilization:        'Izkoristek linije',
        today_so_far:       'Danes doslej',
        on_duty:            'Na dolžnosti danes',
        morning_shift:      'Dopoldan',
        afternoon_shift:    'Popoldan',
        trend_14_days:      'Zadnjih 14 dni',
        record_entry:       'Največ predelanega v enem vnosu (leto)',
        no_target:          'Cilj ni nastavljen',
        no_roster:          'Razpored za danes ni definiran',
        effective_hours:    'efektivnih ur',
    },
    login: {
        title:        'Prijava',
        username:     'Uporabniško ime',
        password:     'Geslo',
        submit:       'Prijava',
        error:        'Napačno uporabniško ime ali geslo',
        pick_who:     'Izberi, kdo si',
        no_operators: 'Trenutno ni na voljo nobenega delavca za prijavo.',
        enter_pin:    'Vnesi svojo 4-mestno kodo',
        wrong_pin:    'Napačna koda',
        choose_pin:   'Izberi svojo kodo',
        choose_pin_help: 'Prvič si prijavljen: začetno kodo zamenjaj s svojo 4-mestno kodo.',
        confirm_pin:  'Ponovi novo kodo',
        pins_differ:  'Kodi se ne ujemata, poskusi znova.',
        pin_same_as_old: 'Nova koda mora biti drugačna od začetne.',
        admin_login:  'Prijava kot administrator',
    },
    general: {
        add:     'Dodaj',
        edit:    'Uredi',
        cancel:  'Prekliči',
        save:    'Shrani',
        delete:  'Izbriši',
        confirm: 'Potrdi',
        yes:     'Da',
        no:      'Ne',
        search:  'Iskanje',
        from:    'Od',
        to:      'Do',
        close:   'Zapri',
    },
    errors: {
        generic_error: 'Prišlo je do napake',
        invalid_data:  'Neveljavni podatki',
        not_found:     'Ni najdeno',
        unauthorized:  'Prijava je potrebna',
        forbidden:     'Za to nimaš pravic',
        duplicate:     'Ta zapis že obstaja',
        overlapping_shift: 'Za ta čas že obstaja vnos — cikel se prekriva z drugim. Preveri začetek in konec.',
        too_many_attempts: 'Preveč napačnih poskusov. Poskusi znova čez 5 minut.',
        on_add:        'Napaka pri dodajanju',
        on_edit:       'Napaka pri urejanju',
    },
    success: {
        add:  'Uspešno dodano',
        edit: 'Uspešno posodobljeno',
    },
    validation: {
        required: 'To polje je obvezno',
        email:    'Neveljaven e-poštni naslov',
    },
}
